import { sagaEffects } from '../../dependencies';
import { saga as disposableExport } from '../../modules/disposable-export';
import { saga as exports } from '../../modules/recurring-exports';

const { all } = sagaEffects;

export default function*() {
    yield all([disposableExport(), exports()]);
}
